import React from 'react';
import { Section, Container } from '../../components';
import Head from './head';
import Items from './items';

export default () => (
  <Section>
    <Container column>
      <Head />
      <Items />
    </Container>
  </Section>
);
